import RaffleRealizedPNG from './raffle_realized.png'
import RaffleNextSoonPNG from './raffle_next_soon.png'
import RaffleWinPNG from './raffle_win.png'
import GameBannerWinPNG from './game_banner_win.png'
import GameBannerLosePNG from './game_banner_lose.png'
import DetailsBannerWinPNG from './details_banner_win.png'
import CarouselGiftPNG from './gift_close_carousel.png'
import ReceiptGiftPNG from './receipt_gift.png'

export const RaffleImages = {
  raffleRealized: <img src={RaffleRealizedPNG} alt="Raffle Realized" />,
  raffleNextSoon: <img src={RaffleNextSoonPNG} alt="Raffle Next" />,
  raffleWin: <img src={RaffleWinPNG} alt="Raffle Win" />,
  gameBannerWin: <img src={GameBannerWinPNG} alt="Game Banner Win" />,
  gameBannerLose: <img src={GameBannerLosePNG} alt="Game Banner Lose" />,
  detailsBannerWin: <img src={DetailsBannerWinPNG} alt="Details Banner Win" />,
  carouselGift: <img src={CarouselGiftPNG} alt="Carosel Gift" />,
  receiptGift: <img src={ReceiptGiftPNG} alt="Receipt Gift" />,
}

export default RaffleImages
